import { Module } from 'core/Module';
import fastdom from 'fastdom';
import { device } from 'utils/device';

export class VideoPlayer extends Module {

	private static videoPlayers: VideoPlayer[] = [];
	private $video;
	private isAutoPlay: boolean = false;

	public create(): void {
		this.$video = this.$container;
		VideoPlayer.videoPlayers.push(this);

		this.isAutoPlay = this.config.autoplay || false;

		console.log('this.$video ', this.$video);
	}

	public destroy(): void {
		console.log('destroy video player');
		this.$video = null;
		VideoPlayer.videoPlayers = [];
	}

	public stop() {
		this.$video.pause();
	}

	public scroll(windowY: number): void {
		if (this.isAutoPlay) {
			fastdom.measure(this.checkAutoPlayStopStart.bind(this));
			return;
		}

		if (!this.$video.paused) {
			fastdom.measure(this.checkUserContolledStop.bind(this));
		}
	}

	checkAutoPlayStopStart() {
		if (this.partInViewport(this.$video)) {
			if (this.$video.paused) {
				this.$video.play();
			}
		} else {
			if (!this.$video.paused) {
				this.$video.pause();
			}
		}
	}

	checkUserContolledStop() {
		if (!this.partInViewport(this.$video)) {
			this.$video.pause();
		}
	}

	partInViewport(elem) {
		let rect = elem.getBoundingClientRect();
		let x = rect.left;
		let y = rect.top;
		let ww = device.innerWidth;
		let hw = device.innerHeight;
		let w = elem.clientWidth;
		let h = elem.clientHeight;
		return y < hw && y + h > 0 && x < ww && x + w > 0;
	}
}
